import React from "react";
import { Box } from "@chakra-ui/react";
import Navbar from "../components/Navbar";
import MapProduksiComponent from "../components/MapProduksi";

const DashboardProduksiMap = () => {
  return (
    <Box h="100vh" display="flex" flexDirection="column">
      <Navbar />
      <Box flex="1" zIndex={1}>
        <MapProduksiComponent />
      </Box>
    </Box>
  );
};

export default DashboardProduksiMap;